import { ReactElement } from 'react'

import { CanvasEdgeDocumentation } from '@flowx/designer/shared/components/resource-documentation/react/CanvasEdgeDocumentation'
import { ApplicationResourceType } from '@flowx/designer/shared/entities/application.entity'
import { SequencePoints } from '@flowx/designer/shared/entities/sequence.dictionary'

import { SequenceDocumentationRender } from '../bpmn-diagram.types'

const POPOVER_GAP = 14

type SequenceEdgeDocumentationProps = {
  edgeId: string
  sequence: SequencePoints
  documentation: SequenceDocumentationRender
  readOnly: boolean
  labelX: number
  labelY: number
  onClose: () => void
}

export const SequenceEdgeDocumentation = ({
  edgeId,
  sequence: { flowxUuid },
  documentation,
  readOnly,
  labelX,
  labelY,
  onClose,
}: SequenceEdgeDocumentationProps): ReactElement => (
  <CanvasEdgeDocumentation
    edgeId={edgeId}
    target={{
      resourceType: ApplicationResourceType.Process,
      resourceId: documentation.processResourceId,
      elementType: 'sequence',
      elementId: flowxUuid,
    }}
    label={documentation.labels[flowxUuid] ?? ''}
    saveLabel={(label) => documentation.onLabelChange(flowxUuid, label)}
    gap={POPOVER_GAP}
    labelX={labelX}
    labelY={labelY}
    readOnly={readOnly}
    onClose={onClose}
  />
)
